import * as React from 'react';
import cx from 'classnames';

import { Enum, forwardRefWithAs } from '../../common/types';

export const CKBoxVariant = Enum(
  'default',
  'card',
  'frame',
  'tinted',
  'tinted-frame',
  'well'
);
export type CKBoxVariant = Enum<typeof CKBoxVariant>;

interface CKBoxProps {
  variant?: CKBoxVariant;
  className?: string;
}

export const CKBox = forwardRefWithAs<CKBoxProps, 'div'>(
  ({ as: Comp = 'div', className, children, variant = 'default' }, ref) => {
    const boxClass = cx(
      'ck-box',
      variant !== 'default' && `ck-box--${variant}`,
      className
    );
    return (
      <Comp ref={ref} className={boxClass}>
        {children}
      </Comp>
    );
  }
);
